import './themen-teaser.scss';

import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/scss';

class ThemenTeaser {
    constructor ($element) {
        this.$themenTeaser = $element;
        this.isDesktopBp = window.matchMedia('(min-width: 1024px)');
        this.$sliderContainer = this.$themenTeaser.querySelector('[data-themen-teaser="slider"]');
        this.init();
    }

    init () {
        if (this.$sliderContainer) {
            this.initSlider();
        }

        window.resizeHandler.customFunctions.push(() => {
            this.initSlider();
        });
    }

    initSlider () {
        this.slider = new Swiper(this.$sliderContainer, {
            modules: [Navigation, Pagination],
            slidesPerView: 'auto',
            speed: 500,
            autoHeight: false,
            navigation: {
                el: this.$themenTeaser.querySelector('.themen-teaser__slider-navigation'),
                nextEl: this.$themenTeaser.querySelector('.slider-button-next'),
                prevEl: this.$themenTeaser.querySelector('.slider-button-prev')
            },
            pagination: {
                el: this.$themenTeaser.querySelector('.slider-pagination'),
                type: 'fraction',
                formatFractionCurrent: function (number) {
                    return ('0' + number).slice(-2);
                },
                formatFractionTotal: function (number) {
                    return ('0' + number).slice(-2);
                }
            },
            on: {
                afterInit: () => {
                    if (this.$themenTeaser.querySelector('.slider-button-next').classList.contains('swiper-button-disabled') & this.$themenTeaser.querySelector('.slider-button-prev').classList.contains('swiper-button-disabled')) {
                        this.$themenTeaser.querySelector('.themen-teaser__slider-navigation').style.display = 'none';
                    } else {
                        this.$themenTeaser.querySelector('.themen-teaser__slider-navigation').style.display = 'flex';
                    }
                }
            }
        });
    }
}

export { ThemenTeaser };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $themenTeasers = $context.querySelectorAll('[data-themen-teaser="root"]');

        for (let i = 0; i < $themenTeasers.length; i++) {
            const $themenTeaser = new ThemenTeaser($themenTeasers[i]);
            $themenTeaser.init();
        }
    }
});
